import { Chip, CircularProgress, Container, Dialog, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import { formatDateToHMYMD } from "../../../../../../Helpers/function";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import api from "../../../../../../Apis";
import Swal from "sweetalert2";
import { PostErrorItem } from "./PostErrorItem";
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';

export default function ProcessItem({ process, stt, cookie, handleDeleteProcess, handleRePublishProcess }) {
  const { t, i18n } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [postErrors, setPostError] = useState([]);
  const [is_loading, setIsLoading] = useState(true);
  
  const getStatus = (process) => {
    if (Number(process.total_error) + Number(process.total_success) == Number(process.total)) {
      return <Chip label="Hoàn thành" color="success" />
    } else {
      return <Chip label="Đang chạy..." color="error" />
    }
  }

  const getListPostFromProcess = (process_id, is_publish_error) => {
    setOpenDialog(true)
    const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + cookie
      },
      body: JSON.stringify({
        process_id: process_id,
        is_publish_error: is_publish_error
      })
    };
    fetch(api.get_post_from_process + `?lang=${i18n.language}`, requestOptions)
    .then(res => res.json())
    .then(
        (result) => {
            if (result.success) {
                setPostError(result.data)
            } else {
                Swal.fire(result.message, "", "warning")
            }
            setIsLoading(false)
        } 
    )
  }

  const updatePostError = (index) => {
    const newPostErrors = [...postErrors]
    newPostErrors.splice(index, 1)
    setPostError(newPostErrors);
  }


  const get_process_type = (type) => {
    if (type == "post") {
      return "Bài viết";
    } else if (type == "story") {
      return "Story";
    } else if (type == "reels") {
      return "Reels";
    }
  }

  return (
    <>
      <TableRow>
        <TableCell>{stt}</TableCell>
        <TableCell>{formatDateToHMYMD(process.created_at)}</TableCell>
        <TableCell>{process.name}</TableCell>
        <TableCell>{get_process_type(process.type)}</TableCell>
        <TableCell sx={{fontSize: "30px"}}>{process.total}</TableCell>
        <TableCell sx={{fontSize: "30px"}}>
          {
            process.total_success > 0
            ?
            <span onClick={() => getListPostFromProcess(process.id, 0)} className="cursor-pointer" style={{textDecoration: "underline", fontSize: "30px"}}>{process.total_success}</span>
            :
            0
          }
        </TableCell>
        <TableCell sx={{fontSize: "30px"}}>
          {
            process.total_error > 0
            ?
            <span onClick={() => getListPostFromProcess(process.id, 1)} className="cursor-pointer" style={{textDecoration: "underline", fontSize: "30px"}}>{process.total_error}</span>
            :
            0
          }
        </TableCell>
        <TableCell>
          {getStatus(process)}
        </TableCell>
        <TableCell>
          <Tooltip title={t("process.re_publish_process")} arrow placement="top">
            <CachedIcon 
              className="cursor" 
              color="primary" sx={{
                marginRight: "10px"
              }}
              onClick={() => handleRePublishProcess(process.id)}
            />
          </Tooltip>
          <Tooltip title={t("process.delete_process")} arrow placement="top">
            <DeleteIcon 
              className="cursor" 
              color="error"
              onClick={() => handleDeleteProcess(process.id)}
            />
          </Tooltip>
        </TableCell>
      </TableRow>
      <Dialog open={openDialog} fullWidth="true" maxWidth='md' onClose={() => {setOpenDialog(false)}}>
        {/* <DialogTitle>{t('post.failedPostsList')}</DialogTitle> */}
        <DialogContent>
          <Grid container spacing={2} sx={{paddingBottom: "16px"}}>
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                          <TableCell sx={{ width: "5%" }}>{t("post.table.no")}</TableCell>
                          <TableCell sx={{ width: "30%" }}>Fanpage</TableCell>
                          <TableCell sx={{ width: "20%" }}>{t("post.table.post")}</TableCell>
                          <TableCell sx={{ width: "25%" }}>{t("post.table.facebookWarning")}</TableCell>
                          <TableCell sx={{ width: "20%" }}>{t("post.table.action.title")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            is_loading
                            ?
                            <TableRow>
                                <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                            :
                            postErrors.map((postItem, index) => {
                              return (
                                // <TableRow>
                                //   <TableCell>{index + 1}</TableCell>
                                //   <TableCell>{postItem?.user_fanpage?.fanpage_name}</TableCell>
                                //   <TableCell>{postItem.log_publish}</TableCell>
                                //   <TableCell>{postItem.log_publish}</TableCell>
                                // </TableRow>
                                <PostErrorItem
                                  post={postItem}
                                  no={index+1}
                                  index={index}
                                  key={index}
                                  cookie={cookie}
                                  updatePostError={updatePostError}
                                />
                              )
                            })
                        }
                    </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
    </Dialog>
    </>
  )
}